import React from "react";
import { Select } from "antd";
import { getCurrentFinancialYear } from "../../services/utils";

const { Option } = Select;

const financialYears = () => {
  const finYears = [];
  const baseYear = 2020;
  const currentYear = new Date().getFullYear();
  // eslint-disable-next-line no-plusplus
  for (let i = baseYear; i <= currentYear; i++) {
    const nextYear = i + 1;
    const currYrTwoDigit = `${i + 1}`.toString().substring(2, 4);
    const currFinYear = `${i}/${currYrTwoDigit}`;
    const nextYrTwoDigit = `${nextYear + 1}`.toString().substring(2, 4);
    const nextFinYear = `${nextYear}/${nextYrTwoDigit}`;
    if (finYears.length <= 12) {
      if (finYears.indexOf(currFinYear) === -1) finYears.push(currFinYear);
      if (finYears.indexOf(nextFinYear) === -1) finYears.push(nextFinYear);
    }
  }
  return finYears;
};

const values = financialYears();

const FYValuesSelect = (props) => {
  return (
    <Select
      {...props}
      id="valueSelect"
      style={{ width: "96vw", maxWidth: "450px" }}
      value={props.value || getCurrentFinancialYear()}
      getPopupContainer={(triggerNode) => triggerNode}
    >
      <Option disabled hidden value="">
        <span style={{ color: "#727272" }}>Select financial year</span>
      </Option>
      {values &&
        values.map((value) => (
          <Option
            key={value}
            value={value}
            style={{ color: "#37519d", border: "0.25px solid #727272", borderRadius: "0", lineHeight: "1.5" }}
          >
            {value}
          </Option>
        ))}
    </Select>
  );
};

export default FYValuesSelect;
